<template>
  <div class="w100 bg-w pt20 pb20 pl20 pr20" style="min-height: 650px;" v-loading="loading">
    <!-- <p class="font-18 tx-c red pb10">第一步：选择图片剪裁</p> -->
    <div class="w100 flex-box">
      <div class="po-r copper-view">
        <VueCropper ref="cropper" :img="upImg" outputType="png" :autoCrop="true" :fixed="true" :autoCropWidth="120" :autoCropHeight="60" :fixedNumber="[1, 0.5]" :fixedBox="true" :canMoveBox="false" @realTime="realTime" />
      </div>
      <div class="pl20 flex-1">
        <p class="mb10 font-14">预览效果：</p>
        <div class="show-preview">
          <div :style="previews.div">
            <img :src="previews.url" :style="previews.img">
          </div>
        </div>
        <div class="w100 mt10">
          <el-button class="w100" @click="showWriteView = true" icon="el-icon-edit">制作手写签名</el-button>
        </div>
        <div class="w100 mt10">
          <label class="btn-file" for="uploads"><i class="el-icon-picture mr5 font-14"></i>{{ upImg == '' ? '选择图片' : '重新选择图片' }}</label>
          <input type="file" v-if="showFileBtn" id="uploads" style="position: absolute; left: 0; top: 0; clip: rect(0 0 0 0); width: 0; height: 0;" accept="image/png, image/jpeg, image/jpg" @change="uploadImg($event)">
        </div>
        <div class="w100 mt10 flex-box" v-show="upImg != ''">
          <el-button class="flex-1" type="warning" @click="rotate('left')">左旋转</el-button>
          <el-button class="flex-1" type="warning" @click="rotate('right')">右旋转</el-button>
          <el-button class="flex-3" type="success" @click="down()">保存当前签名到本机</el-button>
          <a class="none" ref="download" :href="downImg" download="sign"></a>
        </div>
        <div class="w100 mt10">
          <el-button style="width: 300px;" type="danger" icon="el-icon-upload" v-show="upImg != ''" @click="updata">点击上传签名</el-button>
          <p class="mt10 orange">温馨提示：在编辑框内滚动鼠标可以缩放图片</p>
        </div>
      </div>
    </div>

    <el-dialog title="手写签名" :visible.sync="showWriteView" width="700px" :close-on-click-modal="false" :show-close="false">
      <OfficeSignWrite ref="writeView" />
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="clearWrite">清 除</el-button>
        <el-button @click="showWriteView = false">关 闭</el-button>
        <el-button type="primary" @click="setWriteImg">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import { mapState } from "vuex";
import OfficeSignWrite from "@/views/OfficeNew/OfficeSign/Comp/OfficeSignWrite";

export default {
  name: "OfficeSign",
  components: {
    VueCropper,
    OfficeSignWrite
  },
  data() {
    return {
      upImg: "",
      toDeal: 0,
      previews: {},
      downImg: "#",
      loading: false,


      getImg: {
        canvas: null,
        context: null,
        data: null,
        rgbaPicker: "[0,0,0,255]"
      },
      setImg: {
        canvas: null,
        context: null,
        data: null
      },

      showWriteView: false,
      showFileBtn: true
    };
  },
  computed: {
    ...mapState(["userToken", "userData"])
  },
  mounted() {
    // this.initImgView();
  },
  methods: {
    setWriteImg() {
      // console.log(this.$refs.writeView.getWriteImg());
      this.upImg = this.$refs.writeView.getWriteImg();
      this.showFileBtn = false;

      this.$nextTick(() => {
        this.showWriteView = false;
        this.toDeal = 0;
        this.showFileBtn = true;
      });
    },
    clearWrite() {
      this.$refs.writeView.overwrite();
    },
    // getBoundingClientRect(e) {
    //   // console.log(e);
    //   const rect = this.getImg.canvas.getBoundingClientRect();
    //   const x = e.clientX - rect.left;
    //   const y = e.clientY - rect.top;

    //   this.getImg.rgbaPicker = this.getImg.context.getImageData(
    //     x,
    //     y,
    //     1,
    //     1
    //   ).data;
    //   // console.log(this.getImg.rgbaPicker);

    //   this.$nextTick(() => {
    //     for (let index = 0; index < this.getImg.data.data.length; index += 4) {
    //       let r = this.getImg.data.data[index];
    //       let g = this.getImg.data.data[index + 1];
    //       let b = this.getImg.data.data[index + 2];

    //       if (
    //         Math.sqrt(
    //           (r - this.getImg.rgbaPicker[0]) *
    //             (r - this.getImg.rgbaPicker[0]) +
    //             (g - this.getImg.rgbaPicker[1]) *
    //               (g - this.getImg.rgbaPicker[1]) +
    //             (b - this.getImg.rgbaPicker[2]) *
    //               (b - this.getImg.rgbaPicker[2])
    //         ) <= 10
    //       ) {
    //         this.setImg.data.data[index] = 0;
    //         this.setImg.data.data[index + 1] = 0;
    //         this.setImg.data.data[index + 2] = 0;
    //         this.setImg.data.data[index + 3] = 0;
    //       } else {
    //         this.setImg.data.data[index] = r;
    //         this.setImg.data.data[index + 1] = g;
    //         this.setImg.data.data[index + 2] = b;
    //         this.setImg.data.data[index + 3] = this.getImg.data.data[index + 3];
    //       }
    //     }
    //     this.$nextTick(() => {
    //       this.setImg.context.putImageData(this.setImg.data, 0, 0);

    //       console.log(this.setImg);
    //     });
    //   });
    // },
    initImgView() {
      this.getImg.canvas = document.getElementById("getImg");
      this.setImg.canvas = document.getElementById("setImg");

      this.getImg.context = this.getImg.canvas.getContext("2d");
      this.setImg.context = this.setImg.canvas.getContext("2d");
    },
    uploadImg(e) {
      let file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        this.$dialog.alert({
          title: "错误",
          message: "图片类型必须是jpeg,jpg,png,bmp中的一种"
        });
        return false;
      }
      let reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.upImg = data;
      };
      // 转化为base64
      reader.readAsDataURL(file);
      this.toDeal = 1;
      // 转化为blob
      // reader.readAsArrayBuffer(file);
    },
    down() {
      this.$refs.cropper.getCropData(data => {
        this.downImg = data;

        // const img = new Image();
        // img.src = this.downImg;

        // this.$nextTick(() => {
        //     this.getImg.context.drawImage(img, 0, 0, 300, 150);
        //     this.setImg.context.drawImage(img, 0, 0, 300, 150);
        // });

        // this.$nextTick(() => {
        //     this.getImg.data = this.getImg.context.getImageData(0, 0, 300, 150);
        //     this.setImg.data = this.setImg.context.getImageData(0, 0, 300, 150);
        // });
        this.$nextTick(() => {
          this.$refs.download.click();
        });
      });
    },
    updata() {
      this.$refs.cropper.getCropData(data => {
        this.downImg = data;
        const str = this.downImg.substring(this.downImg.indexOf(",") + 1);
        // console.log(this.downImg);
        // console.log("--------");
        // console.log(this.downImg.substring(this.downImg.indexOf(",") + 1));

        this.loading = true;
        this.$http
          .post(
            window.location.origin+
            "/hall/aws/portal/r/jd?sid=" +
              this.userToken +
              "&cmd=com.awspaas.user.apps.flowhall_uploadCachet",
            this.$qs.stringify({
              p1: str,
              toDeal: this.toDeal
            })
          )
          .then(({ data }) => {
            // console.log(data);
            if (data.result == "ok") {
              this.$message({
                message: "签名上传成功",
                type: "success"
              });
            } else {
              this.$message({
                message: "签名上传失败",
                type: "error"
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.$message({
              message: "网络请求错误，请检查网络",
              type: "error"
            });
            this.loading = false;
          });
      });
    },
    realTime(data) {
      this.previews = data;
    },
    rotate(direction) {
      if (direction == "left") {
        this.$refs.cropper.rotateLeft();
      } else {
        this.$refs.cropper.rotateRight();
      }
    }
  }
};
</script>

<style scoped>
#getImg {
  cursor: crosshair;
}

#getImg,
#setImg {
  border: 1px solid #ddd;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC");
}

.copper-view {
  width: 625px;
  height: 400px;
}

.show-preview {
  /* width: 300px;
  height: 150px; */
  width: 120px;
  height: 60px;
  overflow: hidden;
  border: 1px dashed #ddd;
  background: #fafafa;
}

.btn-file {
  display: inline-block;
  padding: 8px 15px;
  width: 300px;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  font-size: 12px;
  background: #409eff;
  color: #fff;
  border-radius: 3px;
}

.off-aws {
  position: absolute;
  right: -30px;
  top: -30px;
}

#awsWindow {
  border: none;
  position: relative;
  width: 100%;
  height: 100%;
}

.aws-window-fix {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 599;
}
.aws-window {
  position: fixed;
  left: 5%;
  top: 5%;
  width: 90%;
  height: 90%;
  background: #fff;
  z-index: 601;
}
</style>

